import { createSlice } from "@reduxjs/toolkit";

const initialSubscriptionState = {
  subscription: {},
  error: null,
  loading: false,
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState: initialSubscriptionState,
  reducers: {
    setSubscriptionData(state, { payload }) {
      state.subscription = payload;
      state.loading = false;
      state.error = null;
    },
    setSubscriptionLoading(state, { payload = true }) {
      state.loading = payload;
    },
    setSubscriptionError(state, { payload }) {
      state.error = payload;
      state.loading = false;
    },
    clearSubscription(state) {
      state.subscription = {};
      state.loading = false;
      state.error = null;
    },
  },
});

export const subscriptionActions = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
